import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useToast } from '@chakra-ui/react';
import { Pagination } from '~/types';
import {
  getPrivacyPolicy,
  getPrivacyPolicyControl,
} from '~/services/PrivacyPolicy';
import { PrivacyPolicyView } from '~/types/privacyPolicy';

export function usePrivacyPolicy(
  page: number,
  assunto = '',
  situacao = '',
  inicio = '',
  fim = '',
  page_size: number | undefined = undefined,
  order = 'DESC',
  order_by = 'data_publicacao',
  options: UseQueryOptions<Pagination<PrivacyPolicyView>, unknown> = {},
): UseQueryResult<Pagination<PrivacyPolicyView>, unknown> {
  const toast = useToast();
  return useQuery<Pagination<PrivacyPolicyView>, unknown>(
    [
      'privacypolicy',
      page,
      assunto,
      situacao,
      inicio,
      fim,
      page_size,
      order,
      order_by,
    ],
    () =>
      getPrivacyPolicy(
        page,
        page_size,
        situacao,
        inicio,
        fim,
        assunto,
        order,
        order_by,
      ),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar termos de uso, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}

export function usePrivacyPolicyControl(
  options: UseQueryOptions<PrivacyPolicyView> = {},
): UseQueryResult<PrivacyPolicyView> {
  const toast = useToast();
  return useQuery<PrivacyPolicyView>(
    ['privacypolicycontrol'],
    () => getPrivacyPolicyControl(),
    {
      staleTime: 1000 * 60 * 3, // 3 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar termos de uso, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}
